import { makeStyles } from '@mui/styles';

const getCellSize = (percentage: number) => {
  return `calc(100% * ${percentage / 100})`;
};

export const useTableRowStyles = makeStyles((theme) => ({
  cell: {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '16px 12px',
  },

  idCell: {
    minWidth: '100px',
    width: getCellSize(12),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(20),
    },
  },

  riskCell: {
    minWidth: '80px',
    paddingLeft: '24px',
    width: getCellSize(8),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(10),
    },
  },

  productTypeCell: {
    minWidth: '80px',
    width: getCellSize(8),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(10),
    },
  },

  timeLeftCell: {
    minWidth: '80px',
    width: getCellSize(10),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(10),
    },
  },

  irrCell: {
    minWidth: '100px',
    width: getCellSize(11),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(18),
    },
  },

  priceCell: {
    minWidth: '110px',
    width: getCellSize(10),

    [theme.breakpoints.up('xl')]: {
      width: getCellSize(16),
    },
  },

  inputCell: {
    display: 'flex',
    maxWidth: 'calc(107px + 32px)',
    minWidth: 'calc(107px + 32px)',
    width: 'calc(107px + 32px)',
    minHeight: 'calc(34px + 36px)',
    flexShrink: 0,
    paddingLeft: '16px',
    paddingRight: '16px',
  },
}));
